import { createAsyncTypes } from 'utils/ActionCreator'

export const INCIDENTS_COUNT_POLLING_ASYNC = createAsyncTypes(
  'INCIDENTS_COUNT_POLLING_ASYNC',
  'Polling'
)

export const DEEPFAKE_NOTIFICATIONS_POLLING_ASYNC = createAsyncTypes(
  'DEEPFAKE_NOTIFICATIONS_POLLING_ASYNC',
  'DeepfakePolling'
)

/**
 * The minimal interval in milliseconds that we can afford assuming
 * functional-value vs operational cost.
 */
export const MINIMAL_ALLOWED_POLLING_INTERVAL = 5000
export const DASHBOARD_POLLING_INTERVAL = 10000
export const DEEPFAKE_POLLING_INTERVAL = 5000
